/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const applyMask = (description: string, value: string) => {
  const applyTimeMask = (input: string) => {
    let numericInput = input.replace(/\D/g, '');

    if (numericInput.length >= 5) {
      numericInput = numericInput.slice(0, 4);
    }

    if (numericInput.length >= 3) {
      numericInput = `${numericInput.substring(0, 2)}:${numericInput.substring(
        2,
        4
      )}`;
    }

    return numericInput;
  };

  const applyNumberMask = (input: string) => {
    return input.replace(/\D/g, '');
  };

  const applyPercentageMask = (input: string) => {
    return input.replace(/\D/g, '').slice(0, 2);
  };

  const applyDateMask = (input: string) => {
    return input.replace(/(\d{2})(\d{2})/, '$1/$2');
  };

  const applyPickingConferenceMask = (input: string) => {
    const normalizedInput = input.toUpperCase().replace(/[^PC]/g, '');

    return normalizedInput.slice(0, 1);
  };

  const applyDotDashMask = (input: string) => {
    const allowedChars = input.replace(
      /[^\-.,\\/!@#$%^&*()_+=<>?;:'"\\[\]{}|`~]/g,
      ''
    );

    const uniqueChars = Array.from(new Set(allowedChars.split(''))).join('');

    return uniqueChars;
  };

  const getExampleFromDescription = (descriptionOrder: string) => {
    if (
      descriptionOrder === "Escolha 'P' para Picking ou 'C' para Conferência"
    ) {
      return 'PC';
    }
    const match = descriptionOrder.match(/ex[:(]\s*([A-Z0-9:/;]+)\s*\)?/i);
    return match ? match[1].trim() : '';
  };

  const applyStreetModuleNivelMask = (input: string) => {
    const upperCaracter = input.toUpperCase();
    const allowedChars = upperCaracter.replace(/[^A-Z-]/g, '').toUpperCase();

    return allowedChars;
  };

  const applyDynamicExampleMask = (example: string, input: string) => {
    const upperCaracter = input.toUpperCase();
    if (/^[A-Z]{2}$/.test(example)) {
      return upperCaracter.replace(/[^A-Z]/g, '').slice(0, 2);
    }

    if (/^\d{2}\/\d{2}$/.test(example)) {
      return applyDateMask(input);
    }

    if (/^\d{2}:\d{2}$/.test(example)) {
      return applyTimeMask(input);
    }

    if (/^\d+$/.test(example)) {
      let valor = parseInt(upperCaracter.replace(/\D/g, '').slice(0, 3), 10);
      valor = Math.min(valor, 100);
      return !Number.isNaN(valor) ? valor.toString() : '';
    }

    return input;
  };

  const example = getExampleFromDescription(description);

  if (!example) {
    return value;
  }

  switch (example) {
    case 'PC':
      return applyPickingConferenceMask(value);
    case 'ponto':
      return applyDotDashMask(value);
    case 'RUA':
      return applyStreetModuleNivelMask(value);
    case '08:00':
      return applyTimeMask(value);
    case 'INTEIRO':
      return applyNumberMask(value);
    case '05;10':
      return value.replace(/\D/g, '');
    case '99':
      return applyPercentageMask(value);
    case 'Segundos':
    case 'Minutos':
      return value.replace(/\D/g, '');
    case '05/10':
      return applyDateMask(value);
    default:
      return applyDynamicExampleMask(example, value);
  }
};
